import { useEffect, useState } from 'react'
import activityApi from '@/apis/activity'
import {
  FormPresentation,
  resolveFormPresentation,
} from '@/pages/application-flow-skins/theme/form-presentation'

interface ChannelDetail {

  /** 渠道模板是表单页 v1/v2 与主题的唯一选择依据。 */
  channelTemplate?: unknown
}

interface PresentationState {

  /** 当前展示结果对应的渠道码，防止渠道码切换时复用上一渠道的皮肤。 */
  adChannelCode: string

  /** 该渠道码的解析状态：加载中、v2 主题或旧表单回退。 */
  presentation: FormPresentation | null | undefined
}

/**
 * useFormPresentation — 加载旧表单容器需要的新版展示配置。
 * Hook 只输出展示版本与主题，不读取或改变旧表单的暂存、提交、定位、埋点和后续分流。
 * @param {string} adChannelCode 旧容器已解析的渠道码
 * @returns {FormPresentation | null | undefined} 加载中的 undefined、有效 v2 配置或沿用旧表单的 null
 */
const useFormPresentation = (
  adChannelCode: string,
): FormPresentation | null | undefined => {
  const [state, setState] = useState<PresentationState>(() => ({
    adChannelCode,
    presentation: adChannelCode ? undefined : null,
  }))

  useEffect(() => {
    if (!adChannelCode) {
      setState({
        adChannelCode,
        presentation: null,
      })
      return undefined
    }

    let active = true
    setState({
      adChannelCode,
      presentation: undefined,
    })
    const loadPresentation = async() => {
      try {
        const detail = await activityApi.getChannelCodeDetail(adChannelCode) as ChannelDetail
        if (active) {
          setState({
            adChannelCode,
            presentation: resolveFormPresentation(detail),
          })
        }
      } catch (error) {
        // 展示配置不可用时不触碰旧业务，继续渲染已稳定的 v1 表单。
        if (active) {
          setState({
            adChannelCode,
            presentation: null,
          })
        }
      }
    }

    loadPresentation()
    return () => {
      active = false
    }
  }, [adChannelCode])

  // 渠道码刚切换的当前渲染不能复用上一渠道的结果，必须保持加载态直到新配置落定。
  if (!adChannelCode) {
    return null
  }

  return state.adChannelCode === adChannelCode ? state.presentation : undefined
}

export default useFormPresentation
